<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><em class="fas fa-scroll"></em></span>{{ 'BookingSearch.ForwarderHeader' | translate }}
  </h1>
  <p-card>
    <p-accordion (onOpen)="bookingAccordionTabOpen()">
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <div class="flex justify-content-end">
          <laas-search-form-parameter-group
            #parameterGroup
            [formName]="preferenceKey"
            [parameters]="searchParams"
            (parameterGroupChange)="parameterGroupChange($event)"
            (unBookmarked)="unBookmarked($event)"
          ></laas-search-form-parameter-group>
        </div>
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'BookingSearch.Form.Facility' | translate }}</label>
              <div class="item">
                <laas-facility-dropdown
                  formControlName="facilityList"
                  [isMultiple]="true"
                  [showFilter]="true"
                  [showToggleAll]="true"
                  (onOptionDataChange)="optionsDataOnChange($event, 'facilityList')">
                </laas-facility-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.Forwarder" | translate }}</label>
              <div class="item">
                <p-multiSelect
                  formControlName="bookingForwarder"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [(ngModel)]="searchParams.bookingForwarder"
                  [options]="bookingForwarderList"
                  [filter]="true"
                  filterBy="label"
                >
                </p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.DeliveryCategory" | translate }}</label>
              <div class="item">
                <p-dropdown
                  formControlName="deliveryCategory"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [showClear]="true"
                  [(ngModel)]="searchParams.deliveryCategory"
                  [options]="deliveryCategoryList"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.BookingType" | translate }}</label>
              <div class="item">
                <p-dropdown
                  formControlName="bookingType"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [showClear]="true"
                  [(ngModel)]="searchParams.bookingType"
                  [options]="bookingTypeList"
                >
                </p-dropdown>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.BookingNo" | translate }}</label>
              <p-chips
                formControlName="bookingNoList"
                [(ngModel)]="searchParams.bookingNoList"
                separator=","
                (onAdd)="chipsAdd($event,'bookingNoList')"
              >
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.BookingStatus" | translate }}</label>
              <div class="item">
                <p-multiSelect
                  formControlName="bookingStatus"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [(ngModel)]="searchParams.bookingStatus"
                  [options]="bookingStatusOptions"
                [filter]="true"
                filterBy="label"
              ></p-multiSelect>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.CarTrip" | translate }}</label>
              <p-chips formControlName="carTrips" [(ngModel)]="searchParams.carTrips" separator="," (onAdd)="chipsAdd($event,'carTrips')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.ConsigneeKey" | translate }}</label>
              <p-chips
                formControlName="consigneeKey"
                [(ngModel)]="searchParams.consigneeKey"
                separator=","
                (onAdd)="chipsAdd($event,'consigneeKey')"
            ></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.ChargesStatus" | translate }}</label>
              <p-dropdown
                formControlName="chargeStatus"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [showClear]="true"
                [options]="chargeStatusList"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.LetterHead" | translate }}</label>
              <p-multiSelect
                formControlName="letterOrgId"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [(ngModel)]="searchParams.letterOrgId"
                [options]="letterOrgIdList"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.LoadOrderComp" | translate }}</label>
              <p-multiSelect
                formControlName="orgId"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [(ngModel)]="searchParams.orgId"
                [options]="orgIdList"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.BillComp" | translate }}</label>
              <p-multiSelect
                formControlName="billCorp"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [(ngModel)]="searchParams.billCorp"
                [options]="billCorpList"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">{{ "BookingSearch.Form.DONo" | translate }}</div>
              <p-chips
                formControlName="doNo"
                [(ngModel)]="searchParams.doNo"
                separator=","
                (onAdd)="chipsAdd($event,'doNo')"
              >
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                  #createDt
                  [title]="'BookingSearch.Form.CreateDate'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'createDt')">
                </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-3 laas-calendar">
              <laas-calendar
                  #assignDate
                  [title]="'BookingSearch.Form.AssignDate'"
                  [enableMaxDateIsToday]="false"
                  [showRangeMode]="true"
                  [showStartMode]="true"
                  (onDateChange)="dateOnChange($event,'assignDate')">
                </laas-calendar>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <div class="mb-1">{{ "BookingSearch.Form.LocalSection" | translate }}</div>
              <p-dropdown
                formControlName="area"
                [filter]="true"
                filterBy="label"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [showClear]="true"
                [(ngModel)]="searchParams.area"
                [options]="areaList"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.CarSeq" | translate }}</label>
              <p-dropdown
                formControlName="carSeq"
                optionLabel="optionDesc"
                optionValue="optionCode"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [showClear]="true"
                [(ngModel)]="searchParams.carSeq"
                [options]="carSeqList"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'BookingSearch.Form.DOInvoiceNum' | translate }}</label>
              <p-chips formControlName="invoiceNo" [(ngModel)]="searchParams.invoiceNo" separator="," (onAdd)="chipsAdd($event,'invoiceNo')"></p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.CreatedBy" | translate }}</label>
              <p-chips formControlName="createUserList" [(ngModel)]="searchParams.createUserList" separator="," (onAdd)="chipsAdd($event,'createUserList')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.HAWB" | translate }}</label>
              <p-chips formControlName="hawbs" [(ngModel)]="searchParams.hawbs" separator="," (onAdd)="chipsAdd($event,'hawbs')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.MAWB" | translate }}</label>
              <p-chips formControlName="mawbs" [(ngModel)]="searchParams.mawbs" separator="," (onAdd)="chipsAdd($event,'mawbs')">
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.FeeRemarks" | translate }}</label>
              <p-dropdown
                formControlName="isFeeCaculation"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [showClear]="true"
                [(ngModel)]="searchParams.isFeeCaculation"
                [options]="isFeeCalculationOptions"
              >
              </p-dropdown>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.ReceiptFormNum" | translate }}</label>
              <p-chips
                formControlName="whNo"
                [(ngModel)]="searchParams.whNo"
                separator=","
                (onAdd)="chipsAdd($event,'whNo')"
              >
              </p-chips>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.ShipCorp" | translate }}</label>
              <p-multiSelect
                formControlName="shipCorp"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [(ngModel)]="searchParams.shipCorp"
                [options]="shipCorpList"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ "BookingSearch.Form.ShippingMethod" | translate }}</label>
              <p-multiSelect
                formControlName="shippingMethodList"
                optionLabel="label"
                optionValue="value"
                placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [(ngModel)]="searchParams.shippingMethodList"
                [options]="shipMethodOptions"
                [filter]="true"
                filterBy="label"
              >
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-3 mb-3">
              <label>{{ 'BookingPreview.Form.VehicleType' | translate }}</label>
              <laas-car-type-selector
                formControlName="carType"
                [(ngModel)]="searchParams.carType"
              >
              </laas-car-type-selector>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Search' | translate }}"
                (click)="searchBtnClick()"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'Common.Button.Reset' | translate }}"
                class="p-button-secondary ml-2"
                (click)="resetBtnClick($event)"
              ></button>
              <button
                pButton
                pRipple
                label="{{ 'BookingSearch.Form.Button.BatchUpdate' | translate }}"
                class="ml-2"
                (click)="gotoBatchUpdate($event)"
                *ngIf="showBatchUpdateBtn()"
              ></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>

    <div class="mt-2">
      <laas-data-table
        [expandable]="true"
        (rowExpanded)="searchDetailClick($event)"
        [tableKey]="preferenceKey"
        [selectable]="true"
        [(selectedRows)]="selectedBookings"
        [dataKey]="'rownum'"
        [value]="searchResults"
        [defaultColumns]="columns"
        [loading]="isLoading"
        (tableOnPage)="tablePageChange($event)"
        (tableOnSort)="tableSort($event)"
        [lazy]="true"
        [rowsPerPageOptions]="[5,10,25,50,100,200]"
      >
        <ng-template pTemplate="caption">
          <p-menubar [model]="mainItemMenus" styleClass="ml-2"></p-menubar>
        </ng-template>

        <ng-template
          pTemplate="body"
          let-rowData
          let-columns="columns"
          let-expanded="expand"
        >
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'bookingNo'">
                <div class="overflow-text">
                  <a href="javascript: void(0);" (click)="bookingNoLinkClick($event, rowData)">{{ rowData[col.field] }}</a>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'bookingStatus'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: bookingStatusOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'bookingType'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: bookingTypeList | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'billCorp'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: billCorpOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'shipTerm'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: shipTermOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'shippingMethod'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: shipMethodOptions | replaceNullWith: '-' }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'toCountry'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: toCountryOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'toCity'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: toCityOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'assignmentDistrictId'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: assignmentDistrictIdOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'awbAddress'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: awbAddressOptions | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'assignDate'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'createDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date: "yyyy-MM-dd":this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'carSeq'">
                <div class="overflow-text">
                  {{ rowData[col.field].slice(-4) | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isPickupFlag'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: isPickupFlagList | replaceNullWith: "-" }}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isFeeCaculation'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping: isFeeCalculationOptions }}
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date: "yyyy-MM-dd HH:mm:ss":this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-rowData let-rowIndex="rowIndex">
          <laas-data-table
            [tableTitle]="formatTableTitle(rowData)"
            [tableKey]="preferenceKey2"
            [dataKey]="'doNo'"
            [selectable]="true"
            [(selectedRows)]="rowData.doNos"
            [value]="rowData.bookingDetails"
            [defaultColumns]="detailColumns"
            [loading]="isLoading"
            [paginator]="false"
            [style]="{ 'overflow-y': 'auto' }"
          >
            <ng-template pTemplate="caption">
              <p-menubar [model]="itemMenus" styleClass="ml-2"></p-menubar>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <td *ngFor="let col of columns">
                <div [ngSwitch]="col.field">
                  <ng-container *ngSwitchCase="'doStatus'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | optionsMapping: DOStatusOptions | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'priority'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | optionsMapping: priorityOptions | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'urgentFlag'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | optionsMapping: priorityOptions | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'shipNotes'">
                    <div class="overflow-text">
                      {{ displayMessageArray(rowData[col.field]) | replaceNullWith: "-" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <ng-container [ngSwitch]="col.dataType">
                      <ng-container *ngSwitchCase="'date'">
                        <div class="overflow-text">
                          {{ rowData[col.field] | date : "yyyy-MM-dd HH:mm:ss" : this.laasSetting.facilityTimeZone | replaceNullWith: "-" }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'array'">
                        <ng-container *ngIf="rowData[col.field].length > 0; else displayEmpty">
                          <ng-container *ngFor="let item of rowData[col.field]; index as i">
                            <div class="overflow-text">
                              {{ i + 1 }}. {{ item + "\t\n" }}
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="overflow-text">
                          {{ rowData[col.field] | replaceNullWith: "-" }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #displayEmpty> - </ng-template>
                </div>
              </td>
            </ng-template>
          </laas-data-table>
        </ng-template>
      </laas-data-table>
    </div>
  </p-card>

  <ng-container *ngIf="showDoFile">
    <laas-dofile-management
      [display]="showDoFile"
      [doNo]="bookingNoFile"
      (onClose)="closeFile($event)"
      [fileType]="'Booking'"
    ></laas-dofile-management>
  </ng-container>

  <ng-container *ngIf="showDoPodFile">
    <laas-dofile-pod-management
      [display]="showDoPodFile"
      [bookingNo]="bookingNoFile"
      (onClose)="closeFile($event)"
      [fileType]="'BookingDetails'"
    ></laas-dofile-pod-management>
  </ng-container>

  <ng-container *ngIf="isShowCertificateModal">
    <laas-certificate-download
      [(visible)]="isShowCertificateModal"
      [booking]="rowData"
      [importDocData]="importDocData"
      (certificateDownloadClick)="remarkSaved($event, rowData)"
    ></laas-certificate-download>
  </ng-container>

  <ng-container *ngIf="isShowBillingViewerModal">
    <laas-billing-viewer
      [display]="isShowBillingViewerModal"
      [bookingNo]="bookingNoFile"
      [bookingInfo]="bookingInfo"
      [feature]="'Booking'"
      [deliverySubType]="bookingInfo.deliverSubType"
      (onClose)="closeBilling($event)"
    ></laas-billing-viewer>
  </ng-container>
</div>
<p-dialog (onShow)="onShowFrontLineDoc($event)" [header]="'DoNo: ' + frontLIneDocReferenceKeyList.join(', ')" [style]="{ width: '90%'}" [(visible)]="isShowTaskDocManagement" appendTo="body" [modal]="true" [draggable]="false" [resizable]="false">
  <laas-task-document #frontLineDoc
  [referenceKeys]="frontLIneDocReferenceKeyList"
  [fileCategory]="fileCategoryForTaskDoc"
  [canEditTable]="false"
  [canUploadDoc]="false"
  [canConfirm]="false"
  [uploadFileType]="uploadFileType"
  [callingFunction]="'bookingSearch'"
  ></laas-task-document>
</p-dialog>

<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
